import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    statusModify: 'idle', // idle loading success fail  
    error: null,
    errorModify: null
}

const WELLSUITE = '../../WsWebServiceWellSuite/';
const PLATFORM = '../../WsWebServicePlatform/';
const HRA = '../../WsWebServiceHra/';
const VI = 'GetViewInstance/';

export const fetchGroups = createAsyncThunk('groups/get', async (incomingVariable, thunkAPI) => {
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.authToken + "/D079FF18-DFDE-4636-AE16-CFBE7DB4A6BB"+'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

// Parent / Name / Active
//Group/Create/{AuthToken}/{GroupName}/{ParentGroupGuid}/{Active}/
export const addGroups = createAsyncThunk('groups/add', async (incomingVariable, thunkAPI) => {
    try {
        const response = await axios.post(PLATFORM + "Group/Create/"
            + incomingVariable.AuthToken + "/"
            + incomingVariable.OrganizationName.replace(" ", "%20") + "/"
            + incomingVariable.OrganizationId_Guid_Parent + "/"
            + incomingVariable.OrganizationActiveFlag + "/"
        )
        const data = await response.data
        return data
    } catch (err) {
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})
// Name / Active
//Group/Update/{AuthToken}/{GroupGuid}/{GroupName}/{Active}/
export const updateGroups = createAsyncThunk('groups/update', async (incomingVariable, thunkAPI) => {
    try {
        const response = await axios.post(PLATFORM + "Group/Update/"
            + incomingVariable.AuthToken + "/"
            + incomingVariable.OrganizationId_Guid + "/"
            + incomingVariable.OrganizationName.replace(" ", "%20") + "/"
            + (incomingVariable.OrganizationActiveFlag === true ? "1" : incomingVariable.OrganizationActiveFlag === false ? "0" :"~~")  + "/"
        )
        const data = await response.data

        return data
    } catch (err) {
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const admingroupslice = createSlice({
    name: 'admingroups',
    initialState,
    reducers: {
        admingroupsClear(state, action) {
            state.entities = initialState.entities
            state.status = 'idle'
            state.error = null
            state.statusModify = 'idle'
            state.errorModify = null
        },
        admingroupsClearModify(state, action) {
            state.statusModify = 'idle'
            state.errorModify = null
        },
        admingroupsModify(state, action) {
            const admingroupsData = action.payload
            state.entities[admingroupsData.Key] = admingroupsData.Value
        },

        admingroupsDelete(state, action) {
            const admingroupsData = action.payload
            delete state.entities[admingroupsData.Key]
        },
        admingroupsHydrate(state, action) {
            const admingroupsData = action.payload
            state.entities = admingroupsData
            state.status = 'success'
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGroups.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchGroups.fulfilled, (state, action) => {
                const loadedData = action.payload.Info[0].ViewInstanceData[0].AdminGroupSelect

                const Groups = loadedData.Groups
                const Cascaded = loadedData.Cascaded
                const Direct = loadedData.Direct
                const data_g = {}
                const data_c = {}
                const data_d = {}

                for (var i = 0; i < Groups.length; i++) {
                    const partObject = Groups[i]
                    data_g[partObject.OrganizationId_Guid] = partObject
                }
                for (var i = 0; i < Cascaded.length; i++) {
                    const partObject = Cascaded[i]
                    data_c[partObject.RelationshipId] = partObject
                }
                for (var i = 0; i < Direct.length; i++) {
                    const partObject = Direct[i]
                    data_d[partObject.RelationshipId] = partObject
                }
                state.entities.groups = data_g
                state.entities.cascaded = data_c
                state.entities.direct = data_d
                state.status = 'success'
            })
            .addCase(fetchGroups.rejected, (state, action) => {
                state.error = action.error.message
            })
            ///
            .addCase(addGroups.pending, (state, action) => {
                state.statusModify = 'loading'
            })
            .addCase(addGroups.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {
                    state.statusModify = 'success'
                    state.errorModify = null
                } else {
                    state.statusModify = 'failed'
                    state.errorModify = action.payload.Status[0]
                }
            })
            .addCase(addGroups.rejected, (state, action) => {
                state.errorModify = action.error.message
            })
            ///
            .addCase(updateGroups.pending, (state, action) => {
                state.statusModify = 'loading'
            })
            .addCase(updateGroups.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {
                    state.statusModify = 'success'
                    state.errorModify = null
                } else {
                    state.statusModify = 'failed'
                    state.errorModify = action.payload.Status[0]
                }
            })
            .addCase(updateGroups.rejected, (state, action) => {
                state.errorModify = action.error.message
            })
    }
})

export const { admingroupsClear, admingroupsModify, admingroupsDelete, admingroupsHydrate, admingroupsClearModify } = admingroupslice.actions

export default admingroupslice.reducer

export const selectAdminGroupsEntities = (state) => state.admingroups.entities.groups
export const selectAdminGroupsCascadedEntities = (state) => state.admingroups.entities.cascaded
export const selectAdminGroupsDirectEntities = (state) => state.admingroups.entities.direct

export const selectAdminGroups = createSelector(selectAdminGroupsEntities, (entities) =>
    Object.values(entities)
)
export const selectAdminGroupCascaded = createSelector(selectAdminGroupsCascadedEntities, (entities) =>
    Object.values(entities)
)
export const selectAdminGroupDirect = createSelector(selectAdminGroupsDirectEntities, (entities) =>
    Object.values(entities)
)


export const selectAdminGroupsById = (state, AdminGroupsId) => {
    return selectAdminGroupsEntities(state)[AdminGroupsId]
}

export const selectAdminGroupsById_Direct = (state, AdminGroupsId) => {
    return selectAdminGroupDirect(state)[AdminGroupsId]
}

export const selectAdminGroupsById_Group = (state, AdminGroupsId) => {
    return selectAdminGroups(state)[AdminGroupsId]
}

export const selectAdminGroupChildrenForParentDirect = createSelector(
    selectAdminGroups
    , selectAdminGroupDirect
    , (state, OrganizationId_Guid_Parent) => OrganizationId_Guid_Parent
    , (groups, children, incomingGuid) => {
        return groups.filter((group) => {
            return children.some((child) => {
                return child.OrganizationId_Guid_Parent === incomingGuid && group.OrganizationId_Guid === child.OrganizationId_Guid_Child
            })
        })
    }
)

export const selectAdminGroupChildrenForParentCascaded = createSelector(
    selectAdminGroups
    , selectAdminGroupCascaded
    , (state, OrganizationId_Guid_Parent) => OrganizationId_Guid_Parent
    , (groups, children, incomingGuid) => {
        return groups.filter((group) => {
            return children.some((child) => {
                return child.OrganizationId_Guid_Parent === incomingGuid && group.OrganizationId_Guid === child.OrganizationId_Guid_Child
            })
        })
    }
)

export const selectAdminGroupsWithoutParents = createSelector(
    selectAdminGroups
    , selectAdminGroupDirect
    , (groups, children) => {
        let childguids = children.map(x => { return x.OrganizationId_Guid_Child })
        return groups.filter((group) => {
            return childguids.indexOf(group.OrganizationId_Guid) < 0
        })
    })


export const selectGroupSelectTree = createSelector(
    selectAdminGroupsWithoutParents
    , selectAdminGroups
    , selectAdminGroupDirect
    , (state, OrganizationId_Guid) => OrganizationId_Guid
    , (parentGroups, allGroups, directRelationships, incomingId) => {
        const dataFormated = (OrganizationId_Guid) => {
            const index = allGroups.map(e => e.OrganizationId_Guid).indexOf(OrganizationId_Guid)
            const Org = allGroups[index]
            return {
                label: Org.OrganizationName
                , value: Org.OrganizationId_Guid
                , checked: incomingId === Org.OrganizationId_Guid
                , expanded: true
                , children: directRelationships.filter((x) => {
                    return x.OrganizationId_Guid_Parent === OrganizationId_Guid
                }
                ).map((m) => { return dataFormated(m.OrganizationId_Guid_Child) })
            }
        }
        return parentGroups.map((x) => dataFormated(x.OrganizationId_Guid))

    }
)